import React from 'react';

const Three: React.FC = () => {
  return (
    <div className="mg-three">
      <div className="mg-three-item">
        <img src="/assets/images/meetings-events/5226d5c176daa595f4db55d4de23caf126e503b3.png" alt="Terrace view" />
      </div>
      <div className="mg-three-item">
        <img src="/assets/images/meetings-events/476a389e59073cbfded36ae33e3246a8855d3f77.png" alt="Interior detail" />
      </div>
      <div className="mg-three-item">
        <img src="/assets/images/meetings-events/81debd7e0047e7bf4ae1a23d7db43d63c1b81226.png" alt="Outdoor space" />
      </div>
    </div>
  );
};

export default Three;